import { getIsRealTime } from "./getIsRealTime";
import { DateShown } from "./DateShown";
import { DateTime } from "luxon";

/**
 * get the selected time range from search parameters
 * @param searchParams 
 * @returns 
 */
export const getDateShownFromSearchParams = (
    searchParams: URLSearchParams
): DateShown => {
    if (searchParams.get("from")) {
        const from = DateTime.fromISO(searchParams.get("from") ?? "");
        if (searchParams.get("to")) {
            const to = DateTime.fromISO(searchParams.get("to") ?? "");
            return [from, to];
        } else {
            return [from, from];
        }
    } else {
        const today = DateTime.now().startOf("day");
        return [today, today];
    }
};

/**
 * get search parameters from the selected time range
 */
export const getSearchParams = (dateShown: DateShown) => {
    const searchParams = new URLSearchParams();
    if (!getIsRealTime(dateShown)) {
        searchParams.set("from", dateShown[0].toISODate());
        searchParams.set("to", dateShown[1].toISODate());
    }
    return searchParams;
}

/**
 * compute the string to append to the url after the path given the search parameters. 
 * If no parameters are set, returns the empty string. Otherwise, returns a '?' character followed by the encoded search parameters
 * @param searchParams
 * @returns 
 */
export const getSearchString = (searchParams: URLSearchParams) => {
    const searchString = searchParams.toString();
    if (searchString) {
        return "?" + searchString;
    }
    return "";
}
